import { ComponentType } from "@angular/cdk/portal";
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

@Injectable({
  providedIn: "root",
})
export class ModalService {
  constructor(private dialog: MatDialog) {}
  openDialog(
    comp: ComponentType<unknown>,
    data?: object,
    panelClass?: string,
    minWidth?: string,
    minHeight?: string,
    width?: string,
    height?: string,
    maxWidth?: string,
    maxHeight?: string
  ) {
   const dialogRef = this.dialog.open(comp, {
      data: data,
      panelClass: panelClass,
      width: width,
      height: height,
      maxWidth: maxWidth,
      minHeight: minHeight,
      maxHeight: maxHeight,
      minWidth: minWidth,
    });
    return dialogRef.afterClosed();
  }
}
